/// <amd-module name="Build/Common/Library/Identity" />
export interface IIdentityRef {
    imageUrl?: string;
    _links?: any;
}

export function getAvatarUrl(identity: IIdentityRef): string {
    let url = "";
    if (identity) {
        url = identity && identity._links && identity._links.avatar && identity._links.avatar.href;
        url = url || identity.imageUrl || "";
    }

    return url;
}
